/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import Stream from 'flarum/common/utils/Stream';
import app from 'flarum/forum/app';

export default class AbstractInput extends Component {
	oninit(vnode) {
		super.oninit(vnode);

		const { groupKey, name, device = null } = this.attrs;

		let currentValue = app.bannerFormState.get(groupKey, name, device);

		if (currentValue === undefined) {
			currentValue = this.defaultValue;
		}

		this.value = new Stream(currentValue);
	}

	onbeforeupdate(vnode) {
		super.onbeforeupdate(vnode);

		const { groupKey, name, device = null } = this.attrs;

		// Update the value in the state
		app.bannerFormState.set(groupKey, name, device, this.value());
	}

	get defaultValue() {
		return '';
	}

	className() {
		return 'BannerInput';
	}

	content() {
		return []; // Child classes should override this method.
	}

	view() {
		return <div className={`Form-group ${this.className()}`}>{this.content()}</div>;
	}
}
